import React from 'react';
import Isvg from 'react-inlinesvg';
import { Alert as ReactstrapAlert } from 'reactstrap';
import AlertIcon from 'app/images/icons/alert.svg';
import InfoIcon from 'app/images/icons/info.svg';
import WarningIcon from 'app/images/icons/warning.svg';

interface IAlertProps {
  children?: any;
  color?: string;
  className?: string;
}

export default class Alert extends React.Component<
  IAlertProps,
  {}
  > {
  static defaultProps: IAlertProps = {
    color: 'warning',
    className: '',
  }

  render() {
    let icon = InfoIcon;
    switch (this.props.color) {
      case 'alert':
        icon = AlertIcon;
        break;
      case 'warning':
        icon = WarningIcon;
        break;
      default:
        icon = InfoIcon;
        break;
    }
    return (
      <ReactstrapAlert className={this.props.className} color={this.props.color}>
        <div className="d-flex justify-content-start align-items-start alert-text">
          <Isvg className="alert-icon" src={icon} />
          {this.props.children}
        </div>
      </ReactstrapAlert>
    );
  }
}
